import { IAppState } from 'App'

export const currentQuestionSelector = (state: IAppState) => {
  const { filteredQuestions, currentQuestionIndex } = state.questions
  return (
    filteredQuestions[currentQuestionIndex] ||
    filteredQuestions[currentQuestionIndex - 1]
  )
}
